import { IdNameModel } from '../../../../../../features/settings/workcalendar/types';
import { workHoursStringArray } from '../../types';

export const getRegion = (id: number, regions: IdNameModel[]): IdNameModel => {
    return regions.filter(x => x.id == id)[0]
}

export const getHours = (hour: number): IdNameModel => {
    return workHoursStringArray.filter(x => x.id == hour)[0];
}